import React, { useEffect, useState, useRef } from 'react'
import styles from './hero.module.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getAllCategoriesThunk, setCategories } from '../../../../redux/category/getAllCategorySlice'
import api from '../../../../utils/api'
import { stripHtmlTags } from '../../../../utils/utils'

const Hero = ({ herobanner }) => {
    const heroRef = useRef(null);
    const { categories, loading, error, filteredCategories } = useSelector((state) => state.categories);

    const [suggestedData, setSuggestedData] = useState([])

    const navigate = useNavigate()
    const [search, setSearch] = useState('')
    const dispatch = useDispatch()

    const placeholders = [
        "Search Microcontrollers...",
        "Search Arduino...",
        "Search STM32...",
        "Search Raspberry Pi..."
    ];
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const [placeholderText, setPlaceholderText] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);

    const searchWrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchWrapperRef.current && !searchWrapperRef.current.contains(event.target)) {
                setSuggestedData([]);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        let timer;
        const currentFullText = placeholders[placeholderIndex];
        const delay = isDeleting ? 40 : 80;

        const handleTyping = () => {
            if (!isDeleting) {
                setPlaceholderText(currentFullText.slice(0, placeholderText.length + 1));
                if (placeholderText.length + 1 === currentFullText.length) {
                    timer = setTimeout(() => setIsDeleting(true), 2200);
                    return;
                }
            } else {
                setPlaceholderText(currentFullText.slice(0, placeholderText.length - 1));
                if (placeholderText.length === 0) {
                    setIsDeleting(false);
                    setPlaceholderIndex((prev) => (prev + 1) % placeholders.length);
                    return;
                }
            }
            timer = setTimeout(handleTyping, delay);
        };

        timer = setTimeout(handleTyping, delay);
        return () => clearTimeout(timer);
    }, [placeholderText, isDeleting, placeholderIndex]);

    const searchCategory = async (e) => {
        if (e) e.preventDefault()
        setSuggestedData([])
        if (search && search.trim()) {
            navigate(`/categories?search=${encodeURIComponent(search.trim())}`)
        }
    }

    const latestQueryRef = useRef('');
    const debounceTimerRef = useRef(null);

    const smartSearch = (text) => {
        setSearch(text);
        latestQueryRef.current = text;
        if (!text.trim()) {
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
            setSuggestedData([]);
            return;
        }
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = setTimeout(async () => {
            const currentQuery = text.trim();
            try {
                const response = await api.smartSearch(`?query=${encodeURIComponent(currentQuery)}&limit=15`);
                if (response.data && latestQueryRef.current.trim() === currentQuery) {
                    setSuggestedData(response.data?.data?.results || []);
                }
            } catch (err) {
                console.log(err);
            }
        }, 180);
    };

    const handlecatclick = (data) => {
        setSuggestedData([])
        if (data?.type == "level3") {
            navigate(`/productList/${data?.name}`)
        } else {
            navigate(`/categories?search=${encodeURIComponent(data?.name)}`)
        }
    }

    const getCleanUrl = (url) => {
        if (!url) return '';
        if (url.includes('asset.electrowiz.in')) {
            return url.replace('https://asset.electrowiz.in', 'https://electrowiz-ap.s3.ap-south-1.amazonaws.com');
        }
        return url;
    };

    const handleClickonsearch = (e) => {
        if (e) e.preventDefault()
        setSuggestedData([])
        if (search && search.trim()) {
            navigate(`/categories?search=${encodeURIComponent(search.trim())}`)
        }
    }

    return (
        <div ref={heroRef} className={styles.headerContainer}>
            <div className={styles.heroMain}>
                <div className={styles.overlay}></div>
                {herobanner?.assets?.url ? (
                    herobanner.assets.type === "IMAGE" ? (
                        <img src={getCleanUrl(herobanner.assets.url)} alt="Hero Banner" />
                    ) : (
                        <video
                            controls={false}
                            autoPlay
                            loop
                            key={getCleanUrl(herobanner.assets.url)}
                            muted
                            style={{ width: '100%', height: "85vh", objectFit: 'cover' }}
                        >
                            <source src={getCleanUrl(herobanner.assets.url)} type="video/mp4" />
                        </video>
                    )
                ) : (
                    <div className={styles.fallbackBg}></div>
                )}
                <div className={styles.heroContent}>
                    <p >{herobanner?.bannerTitle}</p>
                    <div ref={searchWrapperRef} className={styles.searchWrapper}>
                        <form onSubmit={(e) => { e.preventDefault(); handleClickonsearch(); }} className={styles.searchForm}>
                            <div className={styles.searchBarWrapper}>
                                <span className={styles.searchIcon}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder={placeholderText}
                                    className={styles.searchInput}
                                    value={search}
                                    onChange={(e) => smartSearch(e.target.value)}
                                />
                                
                                
                                <button type="submit" className={styles.searchBtn} onClick={() => handleClickonsearch()}>
                                    Search
                                </button>
                                
                                {suggestedData.length > 0 &&
                                    <div className={styles.searchBox}>
                                        <ul>
                                            {
                                                suggestedData.map((i, idx) => (
                                                    <React.Fragment key={idx}>
                                                        {i?.type != "product" ? (
                                                            <li onClick={() => handlecatclick(i)} className={styles.heroSearchItem}>
                                                                <span className={styles.heroSuggestionIcon}>📦</span>
                                                                <div className={styles.heroSuggestionMeta}>
                                                                    <span className={styles.heroSuggestionTitle}>{i?.name}</span>
                                                                </div>
                                                            </li>
                                                        ) : (
                                                            <li onClick={() => navigate(`/ProductCode/${i?.name}`)} className={styles.heroSearchItem}>
                                                                {i?.image ? (
                                                                    <img src={getCleanUrl(i.image)} alt={i.name} className={styles.heroSuggestionImage} />
                                                                ) : (
                                                                    <span className={styles.heroSuggestionIcon}>⚡</span>
                                                                )}
                                                                <div className={styles.heroSuggestionMeta}>
                                                                    <span className={styles.heroSuggestionTitle}>
                                                                        Part: {i?.name}{i?.manufacturer?.[0]?.name ? ` | ${i.manufacturer[0].name}` : ''}
                                                                    </span>
                                                                    {i?.description && (
                                                                        <span className={styles.heroSuggestionDescription}>
                                                                            {stripHtmlTags(i.description)}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={styles.toolExplore}>
                <p>
                    Tools to explore on <span className={styles.purpleText}>Electrowiz</span>
                </p>
                <button 
                    onClick={() => {
                        if (heroRef.current && heroRef.current.nextElementSibling) {
                            heroRef.current.nextElementSibling.scrollIntoView({ behavior: 'smooth' });
                        }
                    }}
                    className={styles.exploreArrowBtn}
                    title="Scroll down"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <polyline points="19 12 12 19 5 12"></polyline>
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Hero